// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2bO15","rootSuccess":"CompleteLink_rootSuccess__3bVMt","rootFailure":"CompleteLink_rootFailure__1Hh-Q","isDisabled":"CompleteLink_isDisabled__3X1fR"};